import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-basketball-line text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-lg font-bold transition-colors ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              乐鱼体育
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/') && location.pathname === '/'
                  ? 'bg-primary-500 text-background-50'
                  : scrolled
                  ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive(`/category/${cat.slug}`)
                    ? 'bg-primary-500 text-background-50'
                    : scrolled
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? 'bg-primary-500 text-background-50'
                  : scrolled
                  ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer whitespace-nowrap text-background-50/90 hover:text-background-50 hover:bg-background-50/10">
              <i className="ri-search-line"></i>
            </button>
            <button className="px-4 py-2 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap">
              订阅资讯
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-800' : 'text-background-50'
            }`}
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors">首页</Link>
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors">
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors">关于我们</Link>
            <button className="mt-2 px-4 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-medium text-center cursor-pointer whitespace-nowrap">
              订阅资讯
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}